import {Button, Div, ImageView, Label} from 'components';
import {Ecolors, Icons} from 'constant';
import React from 'react';
import {navigate} from 'services';
import ComBubble from '../EventRewardScreen/ComBubble';

const size = 160;

function EventRewardCom() {
  return (
    <Button
      onPress={() => {
        navigate('EventRewardScreen');
      }}
      height={size}
      marginTop={24}
      marginHorizontal={16}
      borderRadius={7}
      flexDirection="row"
      overflow="hidden"
      alignItems="center"
      justifyContent="space-between">
      <ImageView source={Icons.bgheader} width={343} height={size} />
      <Div
        position="absolute"
        flexDirection="row"
        paddingHorizontal={16}
        width={'100%'}
        justifyContent="space-between"
        alignItems="center"
        zIndex={999}
        elevation={999}>
        <Div
          widthHeight={55}
          alignItems="center"
          justifyContent="center"
          backgroundColor={Ecolors.gray3x}
          marginRight={8}
          borderRadius={55}>
          <ImageView
            source={Icons.gift}
            resizeMode="contain"
            widthHeight={27}
          />
        </Div>
        <Div flex={1} overflow="visible">
          <Label
            size={14}
            fontWeight="bold">{`eventreward.chuongtrinhlantoa`}</Label>
          <ComBubble isContent4={true} />
        </Div>
        <ImageView
          widthHeight={16}
          resizeMode="contain"
          source={Icons.forward}
        />
      </Div>
    </Button>
  );
}

export default React.memo(EventRewardCom);
